module.exports = __webpack_public_path__ + "static/img/service_online.9b7fee7a.svg";